import { render, staticRenderFns } from "./numberColor.vue?vue&type=template&id=29f943db&scoped=true"
import script from "./numberColor.vue?vue&type=script&lang=js"
export * from "./numberColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f943db",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\baby_doctor_platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29f943db')) {
      api.createRecord('29f943db', component.options)
    } else {
      api.reload('29f943db', component.options)
    }
    module.hot.accept("./numberColor.vue?vue&type=template&id=29f943db&scoped=true", function () {
      api.rerender('29f943db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/colorText/numberColor.vue"
export default component.exports